import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

import reloadQuickOrderInventory from "@crescentParts/Handlers/QuickOrder/ReloadQuickOrderInventory";

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => ({
    selectedWarehouse: state.cpeState.warehouseData.selectedWarehouseForInventory,
});

const mapDispatchToProps = {
    reloadQuickOrderInventory,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const QuickOrderPage = ({ id, selectedWarehouse, reloadQuickOrderInventory }: Props) => {
    useEffect(() => {
        reloadQuickOrderInventory({ reason: "warehouseChanged" });
    }, [selectedWarehouse]);

    return (
        <Page key={selectedWarehouse}>
            <Zone contentId={id} zoneName="Content"></Zone>
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QuickOrderPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "QuickOrderPage" instead of this constant.
 */
export const QuickOrderPageContext = "QuickOrderPage";
